import { useContext } from 'react';
import { Button, Grid, Tooltip, Link } from '@mui/material'; 
import PageTitle from '../../../components/shared/PageTitle';  
import CustomBreadCrumbs from '../../../components/ui/CustomBreadCrumbs';
import { ReportBuilderValues, ReportsBuilderContext } from '../context/ReportsBuilderContext';
import { Save01 } from '../../../assets'; 
import { Link as RouterLink, useLocation } from 'react-router-dom';

const CreateReport=() => {
  const location = useLocation();
  const readOnly = location.state?.readOnly === true;
  const
    {  
      t,
      handleSaveReport,
      handleUpdateReport, 
      isEdit,
      disableCreateReport,
      openGenerate, 
      hasChanges,
      hasFilterConflict, 
    } = useContext(ReportsBuilderContext) as ReportBuilderValues;
  

  const handleSaveClick = () => handleSaveReport(false);
  return (   
    <Grid container>
      <Grid item 
        xs={12}>
        <CustomBreadCrumbs title={!isEdit ? t('createReport') : t('updateReport')}>
          <Link 
            to="/reporting" 
            component={RouterLink}
            sx={{ 
              textDecoration: 'none', 
              color: 'inherit',
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            {t('reports')}
          </Link>
        </CustomBreadCrumbs>
      </Grid>
      <Grid item 
        xs={12}>
        <PageTitle>{!isEdit? t('createReport'): t('updateReport')}</PageTitle>
      </Grid> 
      <Grid item 
        xs ={12}
        sx ={{ display:'flex', justifyContent:'flex-end',alignItems:'flex-end' , gap: '8px' }}>
        <Button size='lg'
          variant='secondary' 
          disabled={disableCreateReport}
          sx={{ display: readOnly ? 'none' : undefined }}
          onClick={openGenerate}>{t('preview')}</Button>
        <Tooltip
          title={  ''}
          disableHoverListener={!hasFilterConflict}
          arrow
        >
          <span>
            <Button
              size="lg"
              sx={{ ml: 3 }}
              onClick={isEdit ? handleUpdateReport : handleSaveClick}
              disabled={
                isEdit
                  ? !hasChanges || disableCreateReport 
                  : disableCreateReport 
              }
            >
              <Save01 />
              {isEdit ? t('update') : t('save')}
            </Button>
          </span>
        </Tooltip> 
      </Grid>
    </Grid> 
   
  );
};

export default CreateReport;
